<form #mainForm (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="row">
        <div class="col-sm-6 clearfix leftSide">
            @for (formField of getLeftSide(); track formField) {
                <div class="form-row left-side-element">
                    <otb-form-field [formField]="formField" [form]="form" [formNumber]="0"></otb-form-field>
                </div>
            }
        </div>
        <div class="col-sm-6 rightSide">
            @for (formField of getRightSide(); track formField) {
                <div class="form-row right-side-element">
                    <otb-form-field [formField]="formField" [form]="form" [formNumber]="0"></otb-form-field>
                </div>
            }
        </div>

        @if (subFormGroups.length > 0) {
            <div id="subForms" [formArrayName]="'subForms'">
                @for (subFormGroup of subFormGroups; track subFormGroup; let i = $index) {
                    <div class="accordion-container mb-5">
                        <div ngbAccordion #acc="ngbAccordion" class="mb-5">
                            <div ngbAccordionItem>
                                <h2 ngbAccordionHeader>
                                    <!-- numbering starts from 1, because we count ADDITIONAL Participants, not all of them -->
                                    <button ngbAccordionButton>Weitere teilnehmende Person {{ i + 1 }}</button>
                                </h2>
                                <div ngbAccordionCollapse>
                                    <div class="row" ngbAccordionBody>
                                        <div class="col-sm-6 clearfix leftSide">
                                            @for (formField of getLeftSideSub(); track formField) {
                                                <div class="form-row left-side-element">
                                                    @if (formField) {
                                                        <otb-form-field
                                                            [formField]="formField"
                                                            [form]="subFormGroup"
                                                            [formNumber]="i + 1"
                                                        ></otb-form-field>
                                                    }
                                                </div>
                                            }
                                        </div>
                                        <div class="col-sm-6 rightSide">
                                            @for (formField of getRightSideSub(); track formField) {
                                                <div class="form-row right-side-element">
                                                    @if (formField) {
                                                        <otb-form-field
                                                            [formField]="formField"
                                                            [form]="subFormGroup"
                                                            [formNumber]="i + 1"
                                                        ></otb-form-field>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        }

        <div class="col-sm-12" *otbShowInEnv="['default', 'mags-sop']">
            <p
                class="py-3"
                [innerHTML]="
                    'dynamische_frontend_texte.persoenliche_daten.html_content.hinweis' | translate | safeStyle
                "
            ></p>
        </div>

        <div class="col-sm-12 personaldata-btn--container">
            <div class="form-group d-flex justify-content-between gap-2 flex-md-row flex-column mt-4">
                <otb-back-button></otb-back-button>

                <button
                    type="submit"
                    class="btn-success btn order-md-2 order-1 m-0 mb-3 mb-sm-0"
                    accesskey="w"
                    btnPrimaryColorDirective
                    [disabled]="isUploadProgress"
                    [innerHTML]="'dynamische_frontend_texte.shared.button.next' | translate | safeStyle"
                ></button>
            </div>
        </div>
    </div>
</form>
